module.exports = __webpack_public_path__ + "img/ship.9cb5ebee.svg";